import Vue from 'vue';
import Acl from 'vue-browser-acl';
import router from '@router';
import store from '@state/store';
import _find from 'lodash/find';

// example user from backend, you can provide a function
// instead in case the user retrieved asynchronously
const user = () => store.state.auth.user;

Vue.use(
  Acl,
  user,
  (acl) => {
    acl.rule('administrate', (user) => {
      if (!user.roles.length) {
        return false;
      }
      return !!_find(user.roles, { name: 'admin' });
    });
    acl.rule('superAdministrate', (user) => {
      if (!user.roles.length) {
        return false;
      }
      return !!_find(user.roles, { name: 'super-admin' });
    });
    acl.rule('doAccounting', (user) => {
      if (!user.roles.length) {
        return false;
      }
      return !!_find(user.roles, { name: 'accounting' });
    });
    acl.rule('doAccountingOrSuperAdministrate', (user) => {
      if (!user.roles.length) {
        return false;
      }
      const isAccounting = !!_find(user.roles, { name: 'accounting' });
      const isSuperAdmin = !!_find(user.roles, { name: 'super-admin' });
      return isAccounting || isSuperAdmin;
    });
  },
  { router }
);
